module.exports = __webpack_public_path__ + "img/card&chip.5f372035.png";